<template>
  <div class="py-2">
    <div>
      <v-btn
        text
        small
        color="grey darken-1"
        class="text-none"
        @click="dialogVisible = true"
      >
        <v-icon
          left
          small
          color="grey darken-1"
        >
          fa fa-cog
        </v-icon>
        Configure matching
      </v-btn>
    </div>
    <content-dialog
      small-title
      max-width="400px"
      :visible.sync="dialogVisible"
    >
      <template v-slot:dialogTitle>
        Matching parameters - #{{ yacht.id }} {{ yacht.name }}
      </template>

      <v-card-text>
        <v-alert
          type="info"
          dense
          outlined
          text
          class="caption mb-4"
        >
          Matching parameters will not apply immediately. They will be applied on next daily data sync.
        </v-alert>
        <div class="mb-1">
          <v-checkbox
            v-model="params.match_model"
            label="Match by exact yacht model"
            color="grey darken-2"
            class="pa-0 ma-0"
            hide-details
          />
        </div>
        <v-row
          v-if="!params.match_model"
          no-gutters
          align="center"
        >
          <v-col
            cols="auto"
            class="caption"
          >
            Length (ft)
          </v-col>
          <v-col class="px-2">
            <v-text-field
              v-model="params.length_min"
              dense
              filled
              type="number"
              placeholder="From"
            />
          </v-col>
          <v-col class="pl-2">
            <v-text-field
              v-model="params.length_max"
              dense
              filled
              type="number"
              placeholder="To"
            />
          </v-col>
        </v-row>
        <v-row
          v-if="!params.match_model"
          no-gutters
          align="center"
        >
          <v-col
            cols="auto"
            class="caption"
          >
            Cabins
          </v-col>
          <v-col class="px-2">
            <v-text-field
              v-model="params.cabins_min"
              dense
              filled
              type="number"
              placeholder="From"
            />
          </v-col>
          <v-col class="pl-2">
            <v-text-field
              v-model="params.cabins_max"
              dense
              filled
              type="number"
              placeholder="To"
            />
          </v-col>
        </v-row>
        <div class="mb-1">
          <v-checkbox
            v-model="params.match_build_year"
            label="Match by build year"
            color="grey darken-2"
            class="pa-0 ma-0"
            hide-details
          />
        </div>
        <v-row
          v-if="params.match_build_year"
          no-gutters
          align="center"
        >
          <v-col
            cols="auto"
            class="caption"
          >
            Build year
          </v-col>
          <v-col class="px-2">
            <v-text-field
              v-model="params.build_year_min"
              dense
              filled
              type="number"
              placeholder="From"
            />
          </v-col>
          <v-col class="pl-2">
            <v-text-field
              v-model="params.build_year_max"
              dense
              filled
              type="number"
              placeholder="To"
            />
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="5">
            Generator
          </v-col>
          <v-col>
            <v-btn-toggle
              v-model="params.generator"
              dense
            >
              <v-btn :value="true">
                Yes
              </v-btn>
              <v-btn :value="false">
                No
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="5">
            A/C
          </v-col>
          <v-col>
            <v-btn-toggle
              v-model="params.ac"
              dense
            >
              <v-btn :value="true">
                Yes
              </v-btn>
              <v-btn :value="false">
                No
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="5">
            Watermaker
          </v-col>
          <v-col>
            <v-btn-toggle
              v-model="params.watermaker"
              dense
            >
              <v-btn :value="true">
                Yes
              </v-btn>
              <v-btn :value="false">
                No
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="5">
            Heating
          </v-col>
          <v-col>
            <v-btn-toggle
              v-model="params.heating"
              dense
            >
              <v-btn :value="true">
                Yes
              </v-btn>
              <v-btn :value="false">
                No
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="5">
            Inverter
          </v-col>
          <v-col>
            <v-btn-toggle
              v-model="params.inverter"
              dense
            >
              <v-btn :value="true">
                Yes
              </v-btn>
              <v-btn :value="false">
                No
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="5">
            Solar panels
          </v-col>
          <v-col>
            <v-btn-toggle
              v-model="params.solar"
              dense
            >
              <v-btn :value="true">
                Yes
              </v-btn>
              <v-btn :value="false">
                No
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
      </v-card-text>

      <template v-slot:dialogActions>
        <v-spacer />
        <v-btn
          color="primary"
          :loading="saving"
          @click="submit()"
        >
          Save
        </v-btn>
      </template>
    </content-dialog>
  </div>
</template>

<script>
import ContentDialog from '@/components/helpers/Dialog.vue'
import Yacht from '@/models/Yacht'

export default {
    name: 'YachtModelBookingPricelistSettings',
    components: {
      ContentDialog
    },
    props: {
      yacht: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        dialogVisible: false,
        params: {
          match_model: true,
          length_min: 0,
          length_max: 60,
          cabins_min: 4,
          cabins_max: 6,
          match_build_year: false,
          build_year_min: null,
          build_year_max: null,
          generator: null,
          ac: null,
          watermaker: null,
          solar: null,
          inverter: null,
          heating: null
        },
        saving: false
      }
    },
    computed: {
    },
    watch: {
    },
    mounted() {
      if (this.yacht.nausys_matching_params) this.params = this.yacht.nausys_matching_params
    },
    methods: {
      async submit () {
        this.saving = true

        const data = { nausys_matching_params: this.params }

        try {
          let updatedYacht = await Yacht.api.updateYacht(data, this.yacht.id)

          this.$emit('update:yacht', updatedYacht)

          this.$store.dispatch('alert', {
            'text': 'Matching parameters updated',
            'color': 'success'
          })
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
          throw e
        } finally {
          this.saving = false
        }
      }
    }
  }
</script>
